<div class="card" fxLayoutAlign="space-between center" fxLayout="row" fxLayout.lt-sm="column">
  <div class="card-body" fxLayout="column">
    <h2 style="margin-top: 8px;" class="mobile-text-centered">Dependents</h2>
    <div class="container-fluid">
      <p>
        Expand the information menu for any dependents you wish to enroll in {{agency}} coverage.
      </p>
      <p *ngIf="selfPay.isPebbCobraOE || selfPay.isPebbCobraInitial || selfPay.isRetireeInitial || selfPay.isRetireeOE || selfPay.isSebbCOBRA || selfPay.isLwopInitial || selfPay.isLwopOE">
        Dependents must be eligible under {{agency}} Program rules and include your:
      </p>
      <p *ngIf="!selfPay.isPebbCobraOE && !selfPay.isPebbCobraInitial && !selfPay.isRetireeInitial && !selfPay.isRetireeOE && !selfPay.isSebbCOBRA && !selfPay.isLwopInitial && !selfPay.isLwopOE">
        Dependents are your family members and include your:
      </p>
      <ul>
        <li>Legal spouse.</li>
        <li>
          State-registered domestic partner
          <ng-container *ngIf="selfPay.isPebbCobraOE || selfPay.isPebbCobraInitial || selfPay.isRetireeInitial || selfPay.isRetireeOE || selfPay.isPebbLwopInitial || selfPay.isPebbLwopOE">
            as defined in WAC 182-12-109. A state-registered domestic partner is treated
            the same as a legal spouse except when in conflict with federal law.
          </ng-container>
          <ng-container *ngIf="selfPay.isSebbCOBRA || selfPay.isSebbLwopInitial || selfPay.isSebbLwopOE">
            as defined in WAC 182-31-020. A state-registered domestic partner is treated
            the same as a legal spouse except when in conflict with federal law.
          </ng-container>
          <ul>
            <li>This includes substantially equivalent legal unions from other jurisdictions.</li>
            <li>Strict requirements apply to these partnerships, including that one partner is age 62 or older and you live in the same residence.</li>
          </ul>
        </li>
        <li>Children through the last day of the month in which they turn 26, regardless of marital status, student status, or eligibility for coverage under another plan. This also includes:
          <ul>
            <li>Stepchildren</li>
            <li *ngIf="!selfPay.isRetireeInitial">Children age 26 or older with a disability</li>
            <li *ngIf="selfPay.isRetireeInitial">Children aged 26 or older with a disability</li>
            <li *ngIf="!selfPay.isCobraOE && !selfPay.isRetireeOE && !selfPay.isSebbLwopOE">Extended dependents</li>
            <li *ngIf="selfPay.isCobraOE || selfPay.isRetireeOE || selfPay.isSebbLwopOE">Extended dependents in certain situations</li>
            <li *ngIf="selfPay.isCOBRA || selfPay.isRetiree || selfPay.isSebbLwopOE || selfPay.isLwopInitial || selfPay.isPebbLwopOE">Children for whom the subscriber has assumed a legal responsibility for support ahead of adoption</li>
          </ul>
        </li>
      </ul>
      <ng-container *ngIf="selfPay.isRetireeInitial || selfPay.isRetireeOE">
        <p>
         Learn more about <a href="https://www.hca.wa.gov/employee-retiree-benefits/retirees/dependents" target="_blank">eligible dependents</a>.
        </p>
      </ng-container>
      <span *ngIf="selfPay.isCobraInitial || selfPay.isCobraSOE || selfPay.isRetireeSOE || selfPay.isSebbCobraOE">
        <p>
          To add new dependents to coverage (not continuing existing coverage) you will need a qualifying event.
          <a *ngIf="selfPay.isRetireeSOE" href="https://www.hca.wa.gov/employee-retiree-benefits/retirees/what-special-open-enrollment" target="_blank">
            Learn about special open enrollments.
          </a>
          <a *ngIf="selfPay.isPebbCobraInitial" href="https://www.hca.wa.gov/employee-retiree-benefits/pebb-continuation-coverage/what-special-open-enrollment" target="_blank">
            Learn about special open enrollments.
          </a>
          <a *ngIf="selfPay.isRetireeInitial" href="https://www.hca.wa.gov/employee-retiree-benefits/retirees/what-special-open-enrollment" target="_blank">
            Learn about special open enrollments.
          </a>
          <a *ngIf="selfPay.isPebbCobraSOE" href="https://www.hca.wa.gov/employee-retiree-benefits/public-employees/change-your-coverage" target="_blank">
            Learn about special open enrollments.
          </a>
          <a *ngIf="selfPay.isSebbCobraOE" href="https://www.hca.wa.gov/employee-retiree-benefits/sebb-continuation-coverage/what-special-open-enrollment" target="_blank">
            Learn about special open enrollments.
          </a>
        </p>
        <p *ngIf="!selfPay.isCobraInitial && !selfPay.isSebbCobraOE">
          You may enroll your legal spouse, state-registered domestic partner, or your children. State-registered domestic partner is defined in
          {{ ((selfPay.isRetireeSOE || selfPay.isPebbCobraInitial) ? 'WAC 182-12-109' : 'WAC 182-31-020') }}.
          Individuals in state-registered domestic partnerships are treated the same as legal spouses except when in conflict with federal law.
        </p>
        <p *ngIf="!selfPay.isCobraInitial && !selfPay.isSebbCobraOE">
          Children must be eligible under {{agency}} Program rules. This includes children through the month of their 26th birthday regardless of marital
          status, student status, or eligibility for coverage under another plan, and children age 26 or older with a disability. Learn more about
          <a [href]="selfPay.isRetireeSOE ? 'https://www.hca.wa.gov/employee-retiree-benefits/retirees/are-my-dependents-eligible' : (agency === 'PEBB' ? 'https://www.hca.wa.gov/employee-retiree-benefits/pebb-continuation-coverage/are-my-dependents-eligible' : 'https://www.hca.wa.gov/employee-retiree-benefits/sebb-continuation-coverage/are-my-dependents-eligible')" target="_blank">
            eligible dependents.
          </a>
        </p>
      </span>
      <p *ngIf="!selfPay.isRetireeInitial && !selfPay.isCobraSOE && !selfPay.isRetireeSOE && !selfPay.isSebbCobraOE">
        To add new dependents click on "add dependent" and input the required information.
      </p>
      <div fxLayout="row" fxLayoutAlign="start-center">
        <button class="btn btn-primary" (click)="addNewDependent()">Add dependent</button>
      </div>
      <div id="accordTitle" fxLayout="row" fxLayoutAlign="start-center" style="padding-top:15px;">
        <h3 style="margin-top:0;">Current dependents</h3>
        <b style="margin-left: 50px;">
          You must review existing dependent information and coverage options before you can continue.
          <span style="font:inherit;" *ngIf="selfPay.isRetireeInitial">Select the plus sign for each dependent list to review their information</span>
        </b>
      </div>
      <div *ngIf="selfPay.formJson?.dependents.length === 0 || !selfPay.formJson">
        <p>No dependent currently on account</p>
      </div>
      <ngb-accordion [destroyOnHide]="false" [closeOthers]="!selfPay.isRetiree && !selfPay.isPebbCobraOE" [activeIds]="(selfPay.isRetiree || (selfPay.isPEBB && selfPay.isCOBRA))? activeIds : []" #dependentAccord="ngbAccordion">
        <ngb-panel  [id]="dep.socialSecurityNumber || 'dep-' + index" *ngFor="let dep of selfPay.formJson?.dependents; let index = index">
          <ng-template ngbPanelHeader let-opened="opened">
            <button *ngIf="(!selfPay.isRetireeOE && !selfPay.isPebbCobraOE) || dep.confirmed" ngbPanelToggle class="btn btn-link container-fluid text-left pl-0">
              <fa-icon class="hca-not-complete" style="margin-right: 15px;" *ngIf="!opened" [icon]="icons.faPlus"></fa-icon>
              <fa-icon class="hca-complete" style="margin-right: 15px;" *ngIf="opened" [icon]="icons.faMinus"></fa-icon>
              <span *ngIf="dep.lastName && dep.firstName">{{ dep.lastName }}, {{ dep.firstName }}</span>
              <span id="newDep" *ngIf="!dep.lastName || !dep.firstName" style="font-style: italic;">--New--</span>
            </button>
            <button *ngIf="(selfPay.isRetireeOE || selfPay.isPebbCobraOE) && !dep.confirmed" ngbPanelToggle class="btn btn-link container-fluid text-left pl-0">
              <fa-icon class="hca-not-complete" style="margin-right: 15px;" *ngIf="!opened" [icon]="icons.faPlus"></fa-icon>
              <fa-icon class="hca-complete" style="margin-right: 15px;" *ngIf="opened" [icon]="icons.faMinus"></fa-icon>
              <span *ngIf="dep.lastName && dep.firstName">{{ dep.lastName }}, {{ dep.firstName }}</span>
              <span id="newDep" *ngIf="!dep.lastName || !dep.firstName" style="font-style: italic;">--New--</span>
            </button>
          </ng-template>

          <ng-template ngbPanelContent>
            <form nativeControlElement #selfpayAddDependentForm="ngForm" #formContainer>
              <self-pay-dependent-detail *ngIf="dep?.memberId" [agency]="agency" [selfPay]="selfPay" [requestType]="selfPay.selfPayType" [idx]="index" [selfPayDependent]="dep" (submitDependent)="pushDependent($event, index, dep, selfpayAddDependentForm, formContainer)" (closePanel)="dependentAccord.collapseAll()">
              </self-pay-dependent-detail>
              <!-- new as far as this selfPay -->
              <div *ngIf="!dep.memberId" role="radiogroup" [attr.aria-labelledby]="'relationshipType' + index + '_label'">
                <h3 class="mobile-text-centered" [id]="'relationshipType' + index + '_label'">Relation</h3>
                <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill>
                  <div class="form-group required" fxFlex="25">
                    <label [for]="'relationshipTypeId-' || index">Relation</label>
                    <select 
                      [(ngModel)]="dep.relationshipTypeCode"
                      (change)="changeRelationshipType(index, $event)" 
                      required class="form-control" 
                      [name]="'relationshipTypeId-' || index"
                      [id]="'relationshipTypeId-' || index">
                      <option></option>
                      <option *ngFor="let rt of lookups.relationshipTypes | isObsolete" [ngValue]="rt.relationshipTypeCode">{{ rt.relationshipTypeName }}</option>
                    </select>
                  </div>
                  <div *ngIf="dep.relationshipTypeCode && dep.relationshipTypeCode === 'S'" class="form-group" fxFlex="20">
                    <date-picker
                      #psd="ngModel"
                      [id]="'psd-' || index"
                      [name]="'psd-' || index"
                      label="Partnership start date"
                      required
                      [min]="dep.birthDate"
                      [canBeInFuture]="false"
                      [(ngModel)]="dep.partnershipStartDate"></date-picker>
                  </div>
                  <div class="form-group required" fxFlex="25">
                    <label [for]="'relationshipQualifyReasonId-' || index">Qualify reason</label>
                    <select [disabled]="!dep.relationshipTypeCode || !filteredRelationshipQualifyReasons || !filteredRelationshipQualifyReasons[index] || filteredRelationshipQualifyReasons[index].length < 2" 
                      required class="form-control" #relationshipQualifyReason="ngModel" 
                      [name]="'relationshipQualifyReasonId-' || index" 
                      [id]="'relationshipQualifyReasonId-' || index" 
                      [(ngModel)]="dep.relationshipQualifyReasonId">
                      <option></option>
                      <option                                                                                                                                                                                                                                             
                        *ngFor="                      
                          let qr of lookups.relationshipQualifyReasons
                            | isObsolete
                            | allowedValues : filteredRelationshipQualifyReasons[index] : 'relationshipQualifyReasonCode'
                        "
                        [ngValue]="qr.relationshipQualifyReasonId"                                         
                      >
                        {{ qr.relationshipQualifyReasonName }}
                      </option>
                    </select>
                  </div>
                </div>

                <self-pay-dependent-detail [selfPay]="selfPay"
                  [agency]="agency"
                  [idx]="index"
                  [requestType]="selfPay.selfPayType" [idx]="index" [selfPayDependent]="dep"
                  [relationshipTypeCode]="dep.relationshipTypeCode"
                  [partnershipStartDate]="dep.partnershipStartDate"
                  [relationshipQualifyReasonCode]="dep.relationshipQualifyReasonCode"
                  [relationshipQualifyReasonId]="dep.relationshipQualifyReasonId"
                  (submitDependent)="pushDependent($event, index, dep, selfpayAddDependentForm, formContainer)"
                  (closePanel)="collapseAccordAndRemoveDep()">
                </self-pay-dependent-detail>
              </div>
            </form>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
    </div>
    <div fxFlex="100" style="margin-top: 10px" fxLayout="row" fxLayoutAlign="space-around">
      <button (click)="previous.emit()" class="btn btn-secondary">Previous</button>
      <button [disabled]="dependentAccord.activeIds.length > 0 && selfPay.formJson?.dependents?.length > 0" (click)="saveSelfPay.emit(selfPay)" class="btn btn-primary">Continue</button>
    </div>
  </div>
</div>
